import {
	AfterViewInit, Component, ElementRef, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges, ViewChild
} from '@angular/core';
import {Utilities} from '../../utilities/utilities.model';
import {MatStepper} from '@angular/material';
import {FormBuilder, FormGroup, Validators} from '@angular/forms';
import {StepperSelectionEvent} from '@angular/cdk/stepper';

@Component({
	selector: 'amd-stepper',
	templateUrl: './amd-stepper.component.html',
	styleUrls: ['./amd-stepper.component.scss']
})
export class AmdStepperComponent implements OnInit, OnChanges, AfterViewInit {

	@ViewChild('stepper') stepper: MatStepper;
	@ViewChild('stepperEL') stepperEl: ElementRef;

	@Input() currentStep: string;
	/**
	 * stepRawLabels must be a comma-separated list of strings
	 *  example:
	 *    stepRawLabels="string1,string2,string3"
	 */
	@Input() stepRawLabels: string;
	@Input() stepValues: any[];

	@Output() stepChangeEventEmitter: EventEmitter<string> = new EventEmitter<string>();

	selectedIndex = 0;

	stepLabels: string[];

	fakeForms: FormGroup[] = [];

	constructor(public fb: FormBuilder) {
	}

	ngOnInit() {
		if (Utilities.isVoid(this.stepRawLabels)) {
			throw new Error('stepRawLabels is void');
		}

		this.stepLabels = this.stepRawLabels.split(',');

		if (this.stepLabels.length === 0) {
			throw new Error('stepLabels is Empty');
		}
		if (Utilities.isVoid(this.stepValues)) {
			throw new Error('stepValues is void');
		}
		if (this.stepLabels.length !== this.stepValues.length) {
			throw new Error('stepLabels\'s length mismatch with stepValues\'s length');
		}

		if (Utilities.isVoid(this.currentStep)) {
			this.currentStep = this.stepValues[0].toString();
		}

		for (const value of this.stepValues) {
			this.fakeForms.push(this.fb.group({step: ['', Validators.required]}));
		}

		setTimeout(() => {
				this.updateCurrentStep()
			}, 100
		);
	}

	ngOnChanges(changes: SimpleChanges): void {
		if (!Utilities.isVoid(changes.currentStep) && !Utilities.isVoid(changes.currentStep.currentValue)) {
			this.currentStep = changes.currentStep.currentValue;
			setTimeout(() => {
				this.updateCurrentStep()
			}, 100);
		}
	}

	ngAfterViewInit(): void {
		//setTimeout(() => this.updateCurrentStep(), 200);
	}

	private updateCurrentStep() {
		if (!Utilities.isVoid(this.stepper) && !Utilities.isVoid(this.stepper._steps)) {
			this.selectedIndex = this.stepValues.indexOf(this.currentStep);
			if (this.selectedIndex < 0) {
				this.selectedIndex = 0;
			}

			if (this.selectedIndex - 1 >= 0) {
				this.fakeForms[this.selectedIndex - 1].get('step').setValue(this.stepValues[this.selectedIndex - 1]);
			}
			if (this.selectedIndex + 1 < this.stepValues.length) {
				this.fakeForms[this.selectedIndex + 1].get('step').setValue(null);
				this.fakeForms[this.selectedIndex + 1].get('step').reset();
			}
			if (this.selectedIndex < this.stepValues.length) {
				this.fakeForms[this.selectedIndex].get('step').setValue(null);
				this.fakeForms[this.selectedIndex].get('step').reset();
			}

			if (this.selectedIndex > this.stepper.selectedIndex) {
				this.stepper.next();
			} else if (this.selectedIndex < this.stepper.selectedIndex) {
				this.stepper.previous();
			}

			this.updateLines(this.selectedIndex);
		}
	}

	updateLines(selectedIndex: number) {
		const classLine = '.mat-stepper-horizontal-line';
		if (!Utilities.isVoid(this.stepperEl) && !Utilities.isVoid(this.stepperEl.nativeElement)) {
			const lines: Element[] = this.stepperEl.nativeElement.querySelectorAll(classLine);
			for (let i = 0; i < selectedIndex; i++) {
				lines[i].classList.add('mat-stepper-horizontal-line--active');
			}
			for (let i = this.selectedIndex; i < lines.length; i++) {
				lines[i].classList.remove('mat-stepper-horizontal-line--active');
			}
		}
	}

	selectionChangeListener(event: StepperSelectionEvent) {
		let tempSelectedIndex = event.selectedIndex;
		if (tempSelectedIndex < 0 || tempSelectedIndex > this.stepValues.length ) {
			tempSelectedIndex = 0;
		}
		if (tempSelectedIndex < this.selectedIndex) {
			this.stepChangeEventEmitter.emit(this.stepValues[tempSelectedIndex]);
		}
	}
}
